import { Component } from '@angular/core';
import { Routes } from '@angular/router';

import { BaMenuService } from '../theme';
import { PAGES_MENU } from './pages.menu';
import { AuthService } from 'app/services/auth';
import * as _ from 'lodash';

@Component({
  selector: 'pages',
  template: `
    <ba-sidebar class="naoImprime"></ba-sidebar>
    <ba-page-top class="naoImprime"></ba-page-top>
    <div class="al-main">
      <div class="al-content">
        <ba-content-top></ba-content-top>
        <router-outlet></router-outlet>
      </div>
    </div>
    <footer class="al-footer clearfix">
      <!-- <div class="al-footer-right" translate>{{'general.created_with'}} <i class="ion-heart"></i></div> //-->
      <div class="al-footer-right"><a target="_blank" href="http://rlimainfo.com.br"><img src="assets/img/logotipo-Rlima.png"></a></div>
      <div class="al-footer-main clearfix">
        <div class="al-copy">&copy; <a target="_blank" href="http://paranamodapark.com.br" translate>{{'general.pmp'}}</a> {{ano}}</div>
        <!-- <ul class="al-share clearfix">
          <li><i class="socicon socicon-facebook"></i></li>
          <li><i class="socicon socicon-twitter"></i></li>
          <li><i class="socicon socicon-google"></i></li>
          <li><i class="socicon socicon-github"></i></li>
        </ul> //-->
      </div>
    </footer>
    <ba-back-top position="200"></ba-back-top>
    `
})
export class Pages {
  public ano:number = 0;
  constructor(
    private _menuService: BaMenuService,
    private auth: AuthService
  ) {
    this.ano = new Date().getFullYear();
  }

  ngOnInit() {
    let menu = [];
    for (let opcao of PAGES_MENU()) {
      menu.push(Object.assign({}, opcao));
    }
    this.auth.permissoes().then((usuario) => {
      if (!usuario.admin) {
        let permissoes = JSON.parse(usuario.permissoes);
        let montaMenu = (opcao) => {
          if(!opcao.children){
            return (opcao.path == 'dashboard' || permissoes[opcao.path]) ? opcao : null;
          }else{
            opcao.children = _.filter(_.compact(opcao.children.map(montaMenu)),(children:any) => {
              if(!children.children){
                return true;
              }else{
                return children.children.length > 0;
              }
            });
            return opcao;
          }
        };

        menu = menu.map(montaMenu);
      }

      this._menuService.updateMenuByRoutes(<Routes>menu);
    });
  }
}



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/pages/pages.component.ts